import { StoreContext } from './store.context';
import React, { FC, ReactNode, useContext, useMemo } from 'react';
import { RootStore } from './root.store';

export const StoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const store = useMemo(() => {
    return new RootStore();
  }, []);

  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

const useStore = () => {
  const context = useContext(StoreContext);

  if (context === undefined) {
    throw new Error('useStore must be used within StoreProvider');
  }

  return context;
};

export default useStore;
